module.exports = __webpack_public_path__ + "img/project-management.094942fd.svg";